import type { EditorState } from '#packages/stateManagement';

const getCustomTemplateId = (state: EditorState) =>
  state.customTemplate.templateId;
const getIsCustomTemplatePublished = (state: EditorState) =>
  state.customTemplate.isCustomTemplatePublished;

export { getIsCustomTemplatePublished, getCustomTemplateId };
